import { Navigate } from "react-router-dom";
import { lazy } from "react";

const Login = lazy(() => import("../pages/login"));
const ForgotPassword = lazy(() => import("../pages/forgotPassword.jsx")); 
const Otp = lazy(() => import("../pages/otp.jsx"));
const ChangePassword = lazy(() => import("../pages/changePassword.jsx"));
const ResetSuccess = lazy(() => import("../pages/resetSuccess.jsx"));

export const commonRoutes = [
    { 
        path: "/",
        element: <Navigate to="/login" replace />
    },
    {
        path: "/login",
        element: <Login/> ,
    },
    {
        path: "/forgot-password",
        element: <ForgotPassword/> ,
    },
    {
        path: "/otp",
        element: <Otp/> ,
    },
    {
        path: "/change-password",
        element: <ChangePassword/> ,
    },
    {
        path: "/reset-success",
        element: <ResetSuccess/> ,
    },
]